/**
 * Mixin for filter panels that use v-dialog. Ensures Escape always closes the dialog
 * (even when :persistent="persistDialog" is true for unsaved changes).
 */
export default {
    watch: {
        dialog(v) {
            if (v) {
                document.addEventListener('keydown', this._escapeCloseHandler)
            } else {
                document.removeEventListener('keydown', this._escapeCloseHandler)
            }
        },
    },
    mounted() {
        this._escapeCloseHandler = (e) => {
            if (e.key === 'Escape' && this.dialog) {
                e.preventDefault()
                this.dialog = false
            }
        }
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this._escapeCloseHandler)
    },
}
